import { formatTime } from 'utils/general';

const toIntegerOrZero = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? Math.trunc(numericValue) : 0;
};

const Columns = (getActions) => [
  {
    id: "month",
    header: "Month",
    accessor: (r) => r.month,
    sortable: true,
    searchable: true,
  },
  {
    id: "program",
    header: "Program",
    accessor: (r) => r.program_name,
    sortable: true,
    searchable: true,
  },
  {
    id: 'offered',
    header: 'Offered',
    accessor: 'offered',
    sortable: true,
    searchable: true,
  },
  {
    id: 'answered',
    header: 'Answered',
    accessor: 'answered',
    sortable: true,
    searchable: true,
  },
  {
    id: 'abandoned',
    header: 'Abandoned',
    accessor: 'abandoned',
    sortable: true,
    searchable: true,
  },
  {
    id: 'callbacks_vms',
    header: 'Callbacks/VMs',
    accessor: (row) => toIntegerOrZero(row?.callbacks_vms),
    sortable: true,
    searchable: true,
  },
  {
    id: 'abandoned_percentage',
    header: 'Abandoned %',
    accessor: 'abandoned_percentage',
    sortable: true,
    searchable: true,
  },


  {
    id: 'service_level_percentage',
    header: 'Service Level %',
    accessor: 'service_level_percentage',
    sortable: true,
    searchable: true,
  },
  {
    id: 'time_to_answer',
    header: 'Time to Answer',
    sortable: true,
    searchable: true,
    accessor: (row) => formatTime(row.time_to_answer) 
  },
  {
    id: 'asa',
    header: 'ASA',
    sortable: true,
    searchable: true,
    accessor: (row) => formatTime(row.asa)
  },
  {
    id: 'time_to_talk',
    header: 'Time to Talk',
    accessor: (row) => formatTime(row.time_to_talk),
    sortable: true,
    searchable: true,
  },
  {
    id: 'avg_talk',
    header: 'Avg Talk',
    accessor: (row) => formatTime(row.avg_talk),
    sortable: true,
    searchable: true,
  },
  {
    id: 'aftercall_work',
    header: 'Aftercall Work',
    accessor: (row) => formatTime(row.aftercall_work),
    sortable: true,
    searchable: true,
  }, 
  {
    id: 'avg_acw',
    header: 'Avg ACW',
    accessor: (row) => formatTime(row.avg_acw),
    sortable: true,
    searchable: true,
  },
  {
    id: 'handle_time',
    header: 'Handle Time',
    accessor: (row) => formatTime(row.handle_time),
    sortable: true,
    searchable: true,
  },
  {
    id: 'aht',
    header: 'AHT',
    accessor: (row) => formatTime(row.aht),
    sortable: true,
    searchable: true,
  },
  {
    id: "actions",
    header: "Action",
    accessor: ( row ) => getActions(row),
    sortable: false,
    searchable: false,
  },
];


export default Columns;